module.exports = __webpack_public_path__ + "img/h-page4-28.c9d0798c.png";